import React from 'react';
import { useFormContext } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

const Input = ({
  id,
  name,
  label,
  type = 'input',
  validation,
  placeholder,
  className,
  multiline = false,
  rows = 5,
  autoFocus = false,
  disabled = false,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className="relative w-full">
      <label className="input-label">{label}</label>
      {multiline ? (
        <textarea
          id={id}
          disabled={disabled}
          name={name}
          rows={rows}
          autoFocus={autoFocus}
          placeholder={placeholder}
          className={twMerge('input', className)}
          {...register(name, validation)}
        />
      ) : (
        <input
          id={id}
          disabled={disabled}
          type={type}
          name={name}
          autoFocus={autoFocus}
          placeholder={placeholder}
          className={twMerge('input', className)}
          {...register(name, validation)}
        />
      )}
      {errors[name] && <span className="text-xs text-contrast1 mt-1">{errors[name].message}</span>}
    </div>
  );
};

export default Input;
